const EXPRESSION_PREVIEW_OPERATORS = ['and', 'or'] as const;

export function formatRuleExpressionPreview(preview: string): string {
  const lowered = preview.toLowerCase();
  const segments = lowered.split(/("(?:[^"\\]|\\.)*")/);

  return segments
    .map((segment, index) => {
      if (index % 2 === 1) return segment;

      let result = segment;
      for (const operator of EXPRESSION_PREVIEW_OPERATORS) {
        const regex = new RegExp(`\\b${operator}\\b`, 'gi');
        result = result.replace(regex, operator.toUpperCase());
      }
      return result;
    })
    .join('');
}
